import Config from '../../config';
import { requestDispatch2 } from '../../util';
import Stroage from '../../services/api/store';
import CONSTANT from '../../constant';

export const ADD_FEEDBACK = 'ADD_FEEDBACK';
export const CACHE_FEEDBACK = 'CACHE_FEEDBACK';

const addFeedback = (data, successCb, failedCb) => {
    return requestDispatch2(
        ADD_FEEDBACK,
        'Feedback',
        'add',
        {
            description: data.description,
            profession: data.profession,
            contact: data.contact,
            call: data.call,
            suffix: data.suffix,
            attachment: data.attachment,
            os: navigator.userAgent,
            version: Config.appVersion
        },
        successCb,
        failedCb
    );
};

const cache = (cacheData) => {
    Stroage.set(CONSTANT.FEEDBACK_CACHE_KEY, cacheData);
    return {
        type: CACHE_FEEDBACK,
        payload: { cacheData }
    };
};

export default {
    addFeedback,
    cache
};